module.exports = __webpack_public_path__ + "static/media/ic-info.00546840.svg";